// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonElement_root__jeQ4c","small":"ButtonElement_small__uexwb","dark":"ButtonElement_dark__WeasZ","secondary":"ButtonElement_secondary__e52Dc"};